module.exports = __webpack_public_path__ + "static/media/EnterpriseSoftwareDevelopment.f800b7ef.jpg";